// Converts a 24-hour format time string to a 12-hour format time string with AM/PM notation
export function formatTimeTo12HourString(timeString: string) {
  const [hours, minutes] = timeString.split(":");

  const period = +hours >= 12 ? "PM" : "AM";
  const hours12 = +hours % 12 || 12;

  return `${hours12}:${minutes} ${period}`;
}
